const { Configurations } = window;

export default {
  environment: process.env.NODE_ENV,
  api: {
    url: `${process.env.SERVER_API_URL}/${process.env.API_VERSION}`,
  },
  cookies: {
    token: 'satellizer_token',
    policy: 'accepted_cookies_policy',
  },
  paginator: {
    perPage: 25,
  },
  sentry: {
    dsn: process.env.SENTRY_REACT_DSN,
  },
  app: {
    basePath: '/app',
    STRIPE_KEY: process.env.STRIPE_KEY,
    STRIPE_CURRENCY: process.env.CASHIER_CURRENCY,
    APP_FORUM_TOPICS: [],
    ...Configurations,
  },
};
